/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Tooltip } from 'antd';
import ModalRisk from './ModalRisk';
import RopaService from '../../../../../services/Ropa.service';
import UserService from '../../../../../services/UserService';
import { useNavigate, useParams } from 'react-router-dom';
import { t } from 'i18next';
import ModalFail from '../../../../../components/Shared/modal/fail';
import { STATUS_ID } from '../../../../risk-register/STATUS_ID';
import RiskRegisterService from '../../../../../services/RiskRegister.service';
import useNotify from '../../../../../context/Notification/useNotify';
import { ROUTER } from '../../../../../constants/router';

export default function Risk({ editMode, detail, detailInfo }) {
    const [isOpen, setIsOpen] = useState(false);
    const [haveSensitiveData, setHaveSensitiveData] = useState(false);
    const [haveRiskRegister, setHaveRiskRegister] = useState(false);
    const [detailRegister, setDetailRegister] = useState();
    const [isOpenFail, setIsOpenFail] = useState(false);
    const [haveRA, setHaveRA] = useState(false);
    const Navigate = useNavigate();
    let { activityId } = useParams();
    const notify = useNotify();
    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        if (detail?.categoryPersonalData?.sensitiveData) {
            const items = detail?.categoryPersonalData?.sensitiveData;
            if (items.length) {
                setHaveSensitiveData(true);
            }
        }
        const getRiskRegisterHeader = async () => {
            try {
                const { data } =
                    await RiskRegisterService.getRiskRegisterHeader();
                if (data?.resultData) {
                    const item = data?.resultData;
                    setHaveRA(item?.length > 0 ? true : false);
                }
            } catch (err) {
                console.log(err);
            }
        };
        const getRiskAssessmentStatus = async () => {
            const { data } = await RopaService.getRiskAssessmentStatus(
                activityId
            );
            if (data.resultData) {
                // console.log(data.resultData)
                setDetailRegister(data.resultData);
                if (data.resultData?.statusEn === 'Unregister') {
                    setHaveRiskRegister(false);
                    setDetailRegister();
                } else {
                    setHaveRiskRegister(true);
                    setDetailRegister(data.resultData);
                }
            }
        };
        getRiskRegisterHeader();
        getRiskAssessmentStatus();
    }, [detail, haveRA]);

    const getRegistered = async () => {
        let ids = [
            STATUS_ID.REVISE,
            STATUS_ID.DRAFT,
            STATUS_ID.REVIEWED,
            STATUS_ID.WAITING_FOR_REVIEW,
        ];
        try {
            let payload = {
                statusIds: ids.join(','),
                departmentId: 'owner',
                p: 1,
                ps: 10,
                s: 'modify_date',
                sd: 'DESC',
            };
            const { data } = await RiskRegisterService.searchRiskRegisterTab2(
                payload
            );
            const resultData = data?.resultData;
            // console.log(resultData)
            if (resultData?.result?.length > 0) {
                setIsOpen(true);
            } else {
                try {
                    const { data } =
                        await RiskRegisterService.createRiskRegisterInitial({
                            riskAssessmentId: detailInfo?.riskAssessmentId,
                        });
                    if (data.resultCode === 1) {
                        Navigate(
                            `${ROUTER.RISK_MANAGEMENT.RR}/${data?.resultData?.riskRegisterId}`,
                            { state: { mode: 'create' } }
                        );
                    } else {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: data?.errorData?.msg,
                        });
                    }
                } catch (error) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: error,
                    });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4 group">
                <div
                    className="text-sm font-semibold pb-2 flex justify-between items-center"
                    style={{ borderBottom: '3px solid #F4F6FC' }}
                >
                    <span>{t('RR.DataRisk')}</span>
                    <Tooltip
                        placement="bottomRight"
                        // overlayStyle={{minWidth:'23%'}}
                        title={
                            <>
                                <div>&#8226; {t('RR.RiskTooltip1')} </div>
                                <div>&#8226; {t('RR.RiskTooltip2')}</div>
                            </>
                        }
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="30"
                                height="30"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <g clipPath="url(#clip0_6901_47257)">
                                <path
                                    d="M15 9C13.4087 9 11.8826 9.63214 10.7574 10.7574C9.63214 11.8826 9 13.4087 9 15C9 16.5913 9.63214 18.1174 10.7574 19.2426C11.8826 20.3679 13.4087 21 15 21C16.5913 21 18.1174 20.3679 19.2426 19.2426C20.3679 18.1174 21 16.5913 21 15C21 13.4087 20.3679 11.8826 19.2426 10.7574C18.1174 9.63214 16.5913 9 15 9ZM7.5 15C7.5 10.8578 10.8578 7.5 15 7.5C19.1423 7.5 22.5 10.8578 22.5 15C22.5 19.1423 19.1423 22.5 15 22.5C10.8578 22.5 7.5 19.1423 7.5 15Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M15 13.5C15.1989 13.5 15.3897 13.579 15.5303 13.7197C15.671 13.8603 15.75 14.0511 15.75 14.25V18.75C15.75 18.9489 15.671 19.1397 15.5303 19.2803C15.3897 19.421 15.1989 19.5 15 19.5C14.8011 19.5 14.6103 19.421 14.4697 19.2803C14.329 19.1397 14.25 18.9489 14.25 18.75V14.25C14.25 14.0511 14.329 13.8603 14.4697 13.7197C14.6103 13.579 14.8011 13.5 15 13.5ZM16.125 11.625C16.125 11.9234 16.0065 12.2095 15.7955 12.4205C15.5845 12.6315 15.2984 12.75 15 12.75C14.7016 12.75 14.4155 12.6315 14.2045 12.4205C13.9935 12.2095 13.875 11.9234 13.875 11.625C13.875 11.3266 13.9935 11.0405 14.2045 10.8295C14.4155 10.6185 14.7016 10.5 15 10.5C15.2984 10.5 15.5845 10.6185 15.7955 10.8295C16.0065 11.0405 16.125 11.3266 16.125 11.625Z"
                                    fill="#7B67FB"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_6901_47257">
                                    <rect
                                        width="15"
                                        height="15"
                                        fill="white"
                                        transform="translate(7.5 7.5)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </Tooltip>
                </div>

                {/* ไม่มีข้อมูลอ่อนไหว */}
                {/* ไม่มีข้อมูลอ่อนไหว */}
                {/* ไม่มีข้อมูลอ่อนไหว */}
                {/* ไม่มีข้อมูลอ่อนไหว */}
                {/* ไม่มีข้อมูลอ่อนไหว */}

                {!haveSensitiveData ? (
                    <div className="flex flex-col space-y-4 justify-center items-center py-12 text-left">
                        <div className="text-[#65707A] font-semibold text-base">
                            {t('RR.NoRiskAssessment')}
                        </div>
                    </div>
                ) : (
                    <>
                        {!editMode ? (
                            <>
                                {/* มีข้อมูลอ่อนไหว view mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว view mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว view mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว view mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว view mode ยังไม่ได้ลงทะเบียน*/}

                                {!haveRiskRegister ? (
                                    <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                        <div
                                            className="relative w-max"
                                            // cursor-pointer
                                            // onClick={() => setIsOpen(true)}
                                        >
                                            <svg
                                                width="63"
                                                height="63"
                                                viewBox="0 0 63 63"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#A597FF"/> */}
                                                <circle
                                                    opacity="0.2"
                                                    cx="31.5"
                                                    cy="31.5"
                                                    r="23.625"
                                                    fill="#A597FF"
                                                />
                                                <circle
                                                    cx="31.2951"
                                                    cy="31.5002"
                                                    r="17.1818"
                                                    fill="#A597FF"
                                                />
                                                <g clipPath="url(#clip0_6901_35740)">
                                                    <path
                                                        d="M31 35.125C31.4144 35.125 31.8118 34.9604 32.1049 34.6674C32.3979 34.3743 32.5625 33.9769 32.5625 33.5625V24.1875C32.5625 23.7731 32.3979 23.3757 32.1049 23.0826C31.8118 22.7896 31.4144 22.625 31 22.625C30.5856 22.625 30.1882 22.7896 29.8951 23.0826C29.6021 23.3757 29.4375 23.7731 29.4375 24.1875V33.5625C29.4375 33.9769 29.6021 34.3743 29.8951 34.6674C30.1882 34.9604 30.5856 35.125 31 35.125V35.125ZM33.3438 39.0312C33.3438 38.4096 33.0968 37.8135 32.6573 37.374C32.2177 36.9344 31.6216 36.6875 31 36.6875C30.3784 36.6875 29.7823 36.9344 29.3427 37.374C28.9032 37.8135 28.6563 38.4096 28.6562 39.0312C28.6562 39.6529 28.9032 40.249 29.3427 40.6885C29.7823 41.1281 30.3784 41.375 31 41.375C31.6216 41.375 32.2177 41.1281 32.6573 40.6885C33.0968 40.249 33.3438 39.6529 33.3438 39.0312V39.0312Z"
                                                        fill="white"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6901_35740">
                                                        <rect
                                                            width="25"
                                                            height="25"
                                                            fill="white"
                                                            transform="translate(18.5 19.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <div
                                                className={classnames(
                                                    'w-[63px] h-[63px] bg-[#A597FF] opacity-10 rounded-full absolute top-0',
                                                    {
                                                        'group-hover:animate-ping':
                                                            // cursor-pointer
                                                            !editMode,
                                                    }
                                                )}
                                            ></div>
                                        </div>
                                        <p className="text-[#65707A] font-semibold text-base">
                                            {t('RR.WaitingForRiskAssessment')}
                                        </p>
                                    </div>
                                ) : (
                                    <>
                                        {detailRegister?.statusEn ===
                                            'In Progress' && (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <div
                                                    className="relative w-max"
                                                    // cursor-pointer
                                                    // onClick={() => setIsOpen(true)}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#FFC441"/> */}
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#FFC441"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.4999"
                                                            r="17.1818"
                                                            fill="#FFC441"
                                                        />
                                                        <circle
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="17.5"
                                                            fill="#F9C153"
                                                        />
                                                        <path
                                                            d="M39.0675 25.6502C38.959 25.5408 38.83 25.454 38.6878 25.3948C38.5456 25.3355 38.3931 25.3051 38.2391 25.3051C38.0851 25.3051 37.9326 25.3355 37.7904 25.3948C37.6483 25.454 37.5192 25.5408 37.4108 25.6502L28.7191 34.3535L25.0675 30.6902C24.9548 30.5814 24.8219 30.4958 24.6762 30.4384C24.5306 30.381 24.375 30.3529 24.2185 30.3556C24.0619 30.3583 23.9075 30.3918 23.7639 30.4542C23.6203 30.5166 23.4904 30.6067 23.3816 30.7193C23.2728 30.8319 23.1873 30.9649 23.1299 31.1105C23.0725 31.2562 23.0443 31.4117 23.0471 31.5683C23.0498 31.7248 23.0833 31.8793 23.1457 32.0229C23.2081 32.1665 23.2982 32.2964 23.4108 32.4052L27.8908 36.8852C27.9992 36.9945 28.1283 37.0813 28.2704 37.1405C28.4126 37.1998 28.5651 37.2302 28.7191 37.2302C28.8731 37.2302 29.0256 37.1998 29.1678 37.1405C29.31 37.0813 29.439 36.9945 29.5475 36.8852L39.0675 27.3652C39.1859 27.2559 39.2804 27.1233 39.345 26.9757C39.4097 26.8281 39.443 26.6688 39.443 26.5077C39.443 26.3465 39.4097 26.1872 39.345 26.0396C39.2804 25.892 39.1859 25.7594 39.0675 25.6502V25.6502Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#FFC441] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping':
                                                                    // cursor-pointer
                                                                    editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </div>
                                                <p className="text-[#F9C153] font-semibold text-base">
                                                    {t(
                                                        'RR.InProcessOfRiskAssessment'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                        {detailRegister?.statusEn ===
                                            'Registered' && (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <div
                                                    className="relative w-max"
                                                    // cursor-pointer
                                                    // onClick={() => setIsOpen(true)}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#FFC441"/> */}
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#4ACE8F"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.4999"
                                                            r="17.1818"
                                                            fill="#4ACE8F"
                                                        />
                                                        <circle
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="17.5"
                                                            fill="#4ACE8F"
                                                        />
                                                        <path
                                                            d="M39.0675 25.6502C38.959 25.5408 38.83 25.454 38.6878 25.3948C38.5456 25.3355 38.3931 25.3051 38.2391 25.3051C38.0851 25.3051 37.9326 25.3355 37.7904 25.3948C37.6483 25.454 37.5192 25.5408 37.4108 25.6502L28.7191 34.3535L25.0675 30.6902C24.9548 30.5814 24.8219 30.4958 24.6762 30.4384C24.5306 30.381 24.375 30.3529 24.2185 30.3556C24.0619 30.3583 23.9075 30.3918 23.7639 30.4542C23.6203 30.5166 23.4904 30.6067 23.3816 30.7193C23.2728 30.8319 23.1873 30.9649 23.1299 31.1105C23.0725 31.2562 23.0443 31.4117 23.0471 31.5683C23.0498 31.7248 23.0833 31.8793 23.1457 32.0229C23.2081 32.1665 23.2982 32.2964 23.4108 32.4052L27.8908 36.8852C27.9992 36.9945 28.1283 37.0813 28.2704 37.1405C28.4126 37.1998 28.5651 37.2302 28.7191 37.2302C28.8731 37.2302 29.0256 37.1998 29.1678 37.1405C29.31 37.0813 29.439 36.9945 29.5475 36.8852L39.0675 27.3652C39.1859 27.2559 39.2804 27.1233 39.345 26.9757C39.4097 26.8281 39.443 26.6688 39.443 26.5077C39.443 26.3465 39.4097 26.1872 39.345 26.0396C39.2804 25.892 39.1859 25.7594 39.0675 25.6502V25.6502Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#4ACE8F] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping':
                                                                    // cursor-pointer
                                                                    editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </div>
                                                <p className="text-[#4ACE8F] font-semibold text-base">
                                                    {t('RR.RiskRegistered')}
                                                </p>
                                            </div>
                                        )}
                                        {!detailRegister?.statusEn && (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <div
                                                    className="relative w-max"
                                                    // cursor-pointer
                                                    // onClick={() => setIsOpen(true)}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#A597FF"/> */}
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#A597FF"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.5002"
                                                            r="17.1818"
                                                            fill="#A597FF"
                                                        />
                                                        <g clipPath="url(#clip0_6901_35740)">
                                                            <path
                                                                d="M31 35.125C31.4144 35.125 31.8118 34.9604 32.1049 34.6674C32.3979 34.3743 32.5625 33.9769 32.5625 33.5625V24.1875C32.5625 23.7731 32.3979 23.3757 32.1049 23.0826C31.8118 22.7896 31.4144 22.625 31 22.625C30.5856 22.625 30.1882 22.7896 29.8951 23.0826C29.6021 23.3757 29.4375 23.7731 29.4375 24.1875V33.5625C29.4375 33.9769 29.6021 34.3743 29.8951 34.6674C30.1882 34.9604 30.5856 35.125 31 35.125V35.125ZM33.3438 39.0312C33.3438 38.4096 33.0968 37.8135 32.6573 37.374C32.2177 36.9344 31.6216 36.6875 31 36.6875C30.3784 36.6875 29.7823 36.9344 29.3427 37.374C28.9032 37.8135 28.6563 38.4096 28.6562 39.0312C28.6562 39.6529 28.9032 40.249 29.3427 40.6885C29.7823 41.1281 30.3784 41.375 31 41.375C31.6216 41.375 32.2177 41.1281 32.6573 40.6885C33.0968 40.249 33.3438 39.6529 33.3438 39.0312V39.0312Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6901_35740">
                                                                <rect
                                                                    width="25"
                                                                    height="25"
                                                                    fill="white"
                                                                    transform="translate(18.5 19.5)"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#A597FF] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping':
                                                                    // cursor-pointer
                                                                    !editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </div>
                                                <p className="text-[#65707A] font-semibold text-base">
                                                    {t(
                                                        'RR.WaitingForRiskAssessment'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                {/* มีข้อมูลอ่อนไหว edit mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว edit mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว edit mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว edit mode ยังไม่ได้ลงทะเบียน*/}
                                {/* มีข้อมูลอ่อนไหว edit mode ยังไม่ได้ลงทะเบียน*/}

                                {!haveRiskRegister ? (
                                    <>
                                        {!admin ? (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <button
                                                    type="button"
                                                    className="relative w-max cursor-pointer"
                                                    onClick={() => {
                                                        if (haveRA === true) {
                                                            getRegistered();
                                                        } else {
                                                            setIsOpenFail(true);
                                                        }
                                                    }}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#A597FF"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.4997"
                                                            r="17.1818"
                                                            fill="#A597FF"
                                                        />
                                                        <g clipPath="url(#clip0_4746_246955)">
                                                            <path
                                                                d="M32.3375 25.0479H29.9086V29.9057H25.0508V32.3346H29.9086V37.1924H32.3375V32.3346H37.1954V29.9057H32.3375V25.0479Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_4746_246955">
                                                                <rect
                                                                    width="19.6364"
                                                                    height="19.6364"
                                                                    fill="white"
                                                                    transform="translate(21.4766 21.6816)"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#A597FF] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping cursor-pointer':
                                                                    editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </button>
                                                <p className="text-[#65707A] font-semibold text-base">
                                                    {t(
                                                        'RR.PleaseRegisterYourRisk'
                                                    )}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <div
                                                    className="relative w-max"
                                                    // cursor-pointer
                                                    // onClick={() => setIsOpen(true)}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#A597FF"/> */}
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#A597FF"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.5002"
                                                            r="17.1818"
                                                            fill="#A597FF"
                                                        />
                                                        <g clipPath="url(#clip0_6901_35740)">
                                                            <path
                                                                d="M31 35.125C31.4144 35.125 31.8118 34.9604 32.1049 34.6674C32.3979 34.3743 32.5625 33.9769 32.5625 33.5625V24.1875C32.5625 23.7731 32.3979 23.3757 32.1049 23.0826C31.8118 22.7896 31.4144 22.625 31 22.625C30.5856 22.625 30.1882 22.7896 29.8951 23.0826C29.6021 23.3757 29.4375 23.7731 29.4375 24.1875V33.5625C29.4375 33.9769 29.6021 34.3743 29.8951 34.6674C30.1882 34.9604 30.5856 35.125 31 35.125V35.125ZM33.3438 39.0312C33.3438 38.4096 33.0968 37.8135 32.6573 37.374C32.2177 36.9344 31.6216 36.6875 31 36.6875C30.3784 36.6875 29.7823 36.9344 29.3427 37.374C28.9032 37.8135 28.6563 38.4096 28.6562 39.0312C28.6562 39.6529 28.9032 40.249 29.3427 40.6885C29.7823 41.1281 30.3784 41.375 31 41.375C31.6216 41.375 32.2177 41.1281 32.6573 40.6885C33.0968 40.249 33.3438 39.6529 33.3438 39.0312V39.0312Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6901_35740">
                                                                <rect
                                                                    width="25"
                                                                    height="25"
                                                                    fill="white"
                                                                    transform="translate(18.5 19.5)"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#A597FF] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping':
                                                                    // cursor-pointer
                                                                    !editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </div>
                                                <p className="text-[#65707A] font-semibold text-base">
                                                    {t(
                                                        'RR.WaitingForRiskAssessment'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {detailRegister?.statusEn ===
                                            'In Progress' && (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <div
                                                    className="relative w-max"
                                                    // cursor-pointer
                                                    // onClick={() => setIsOpen(true)}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#FFC441"/> */}
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#FFC441"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.4999"
                                                            r="17.1818"
                                                            fill="#FFC441"
                                                        />
                                                        <circle
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="17.5"
                                                            fill="#F9C153"
                                                        />
                                                        <path
                                                            d="M39.0675 25.6502C38.959 25.5408 38.83 25.454 38.6878 25.3948C38.5456 25.3355 38.3931 25.3051 38.2391 25.3051C38.0851 25.3051 37.9326 25.3355 37.7904 25.3948C37.6483 25.454 37.5192 25.5408 37.4108 25.6502L28.7191 34.3535L25.0675 30.6902C24.9548 30.5814 24.8219 30.4958 24.6762 30.4384C24.5306 30.381 24.375 30.3529 24.2185 30.3556C24.0619 30.3583 23.9075 30.3918 23.7639 30.4542C23.6203 30.5166 23.4904 30.6067 23.3816 30.7193C23.2728 30.8319 23.1873 30.9649 23.1299 31.1105C23.0725 31.2562 23.0443 31.4117 23.0471 31.5683C23.0498 31.7248 23.0833 31.8793 23.1457 32.0229C23.2081 32.1665 23.2982 32.2964 23.4108 32.4052L27.8908 36.8852C27.9992 36.9945 28.1283 37.0813 28.2704 37.1405C28.4126 37.1998 28.5651 37.2302 28.7191 37.2302C28.8731 37.2302 29.0256 37.1998 29.1678 37.1405C29.31 37.0813 29.439 36.9945 29.5475 36.8852L39.0675 27.3652C39.1859 27.2559 39.2804 27.1233 39.345 26.9757C39.4097 26.8281 39.443 26.6688 39.443 26.5077C39.443 26.3465 39.4097 26.1872 39.345 26.0396C39.2804 25.892 39.1859 25.7594 39.0675 25.6502V25.6502Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#FFC441] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping':
                                                                    // cursor-pointer
                                                                    editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </div>
                                                <p className="text-[#F9C153] font-semibold text-base">
                                                    {t(
                                                        'RR.InProcessOfRiskAssessment'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                        {detailRegister?.statusEn ===
                                            'Registered' && (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <div
                                                    className="relative w-max"
                                                    // cursor-pointer
                                                    // onClick={() => setIsOpen(true)}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* <circle opacity="0.1" cx="31.5" cy="31.5" r="31.5" fill="#FFC441"/> */}
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#4ACE8F"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.4999"
                                                            r="17.1818"
                                                            fill="#4ACE8F"
                                                        />
                                                        <circle
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="17.5"
                                                            fill="#4ACE8F"
                                                        />
                                                        <path
                                                            d="M39.0675 25.6502C38.959 25.5408 38.83 25.454 38.6878 25.3948C38.5456 25.3355 38.3931 25.3051 38.2391 25.3051C38.0851 25.3051 37.9326 25.3355 37.7904 25.3948C37.6483 25.454 37.5192 25.5408 37.4108 25.6502L28.7191 34.3535L25.0675 30.6902C24.9548 30.5814 24.8219 30.4958 24.6762 30.4384C24.5306 30.381 24.375 30.3529 24.2185 30.3556C24.0619 30.3583 23.9075 30.3918 23.7639 30.4542C23.6203 30.5166 23.4904 30.6067 23.3816 30.7193C23.2728 30.8319 23.1873 30.9649 23.1299 31.1105C23.0725 31.2562 23.0443 31.4117 23.0471 31.5683C23.0498 31.7248 23.0833 31.8793 23.1457 32.0229C23.2081 32.1665 23.2982 32.2964 23.4108 32.4052L27.8908 36.8852C27.9992 36.9945 28.1283 37.0813 28.2704 37.1405C28.4126 37.1998 28.5651 37.2302 28.7191 37.2302C28.8731 37.2302 29.0256 37.1998 29.1678 37.1405C29.31 37.0813 29.439 36.9945 29.5475 36.8852L39.0675 27.3652C39.1859 27.2559 39.2804 27.1233 39.345 26.9757C39.4097 26.8281 39.443 26.6688 39.443 26.5077C39.443 26.3465 39.4097 26.1872 39.345 26.0396C39.2804 25.892 39.1859 25.7594 39.0675 25.6502V25.6502Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#4ACE8F] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping':
                                                                    // cursor-pointer
                                                                    editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </div>
                                                <p className="text-[#4ACE8F] font-semibold text-base">
                                                    {t('RR.RiskRegistered')}
                                                </p>
                                            </div>
                                        )}

                                        {!detailRegister?.statusEn && (
                                            <div className="text-center pt-4 flex flex-col items-center justify-center w-full">
                                                <button
                                                    type="button"
                                                    className="relative w-max cursor-pointer"
                                                    onClick={() => {
                                                        if (haveRA === true) {
                                                            getRegistered();
                                                        } else {
                                                            setIsOpenFail(true);
                                                        }
                                                    }}
                                                >
                                                    <svg
                                                        width="63"
                                                        height="63"
                                                        viewBox="0 0 63 63"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <circle
                                                            opacity="0.2"
                                                            cx="31.5"
                                                            cy="31.5"
                                                            r="23.625"
                                                            fill="#A597FF"
                                                        />
                                                        <circle
                                                            cx="31.2951"
                                                            cy="31.4997"
                                                            r="17.1818"
                                                            fill="#A597FF"
                                                        />
                                                        <g clipPath="url(#clip0_4746_246955)">
                                                            <path
                                                                d="M32.3375 25.0479H29.9086V29.9057H25.0508V32.3346H29.9086V37.1924H32.3375V32.3346H37.1954V29.9057H32.3375V25.0479Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_4746_246955">
                                                                <rect
                                                                    width="19.6364"
                                                                    height="19.6364"
                                                                    fill="white"
                                                                    transform="translate(21.4766 21.6816)"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <div
                                                        className={classnames(
                                                            'w-[63px] h-[63px] bg-[#A597FF] opacity-10 rounded-full absolute top-0',
                                                            {
                                                                'group-hover:animate-ping cursor-pointer':
                                                                    editMode,
                                                            }
                                                        )}
                                                    ></div>
                                                </button>
                                                <p className="text-[#65707A] font-semibold text-base">
                                                    {t(
                                                        'RR.PleaseRegisterYourRisk'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
            <ModalRisk
                detailInfo={detailInfo}
                open={isOpen}
                handelClose={() => setIsOpen(false)}
            />
            <ModalFail
                open={isOpenFail}
                title={t('RR.FailedToRegisterRisk')}
                text={
                    <>
                        {t('RR.FailedToRegisterRiskms1')} <br />
                        {t('RR.FailedToRegisterRiskms2')}
                    </>
                }
                handelClose={() => setIsOpenFail(false)}
            />
        </>
    );
}
